export default __webpack_public_path__ + "static/media/about-us.00beee11.jpg";